(function () {
  function initGridCartForms(root) {
    if (!root || typeof theme === 'undefined' || !theme.AjaxProduct) {
      return;
    }

    root.querySelectorAll('.grid-product__add-form:not([data-cart-init])').forEach(function (form) {
      form.setAttribute('data-cart-init', 'true');

      if (theme.settings && theme.settings.cartType === 'drawer') {
        new theme.AjaxProduct(form);
      }
    });
  }

  function initAll() {
    initGridCartForms(document);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (event) {
    initGridCartForms(event.target);
  });
  document.addEventListener('collection:reloaded', initAll);
})();
